import { Box, BoxProps, HStack, Text } from '@chakra-ui/react';
import * as React from 'react';

import {
    MentorshipModuleIcon,
    MentorshipModuleKey,
    mentorshipModuleFromTitle,
} from '../presentation/MentorshipModulePresentation';

export const MentorshipMemberPageHeader: React.FC<{
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  icon?: MentorshipModuleKey;
}> = ({ title, subtitle, actions, icon }) => {
  const iconKey = icon ?? mentorshipModuleFromTitle(title);
  return (
    <HStack
      justify="space-between"
      align={{ base: 'stretch', md: 'start' }}
      flexDirection={{ base: 'column', md: 'row' }}
      gap="4"
      mb="5"
    >
      <HStack align="start" spacing="3">
        <Box
          mt="1"
          boxSize="34px"
          flexShrink={0}
          borderRadius="md"
          bg="primary.50"
          color="primary.500"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <MentorshipModuleIcon module={iconKey} boxSize="18px" />
        </Box>
        <Box>
          <Text fontSize="2xl" fontWeight="bold" color="gray.900">
            {title}
          </Text>
          {subtitle ? (
            <Text color="gray.600" mt="1">
              {subtitle}
            </Text>
          ) : null}
        </Box>
      </HStack>
      {actions ? <Box flexShrink={0}>{actions}</Box> : null}
    </HStack>
  );
};

export const MentorshipMemberSurface: React.FC<BoxProps> = ({
  children,
  ...props
}) => (
  <Box
    bg="white"
    border="1px solid"
    borderColor="gray.100"
    borderRadius="lg"
    boxShadow="sm"
    p="5"
    {...props}
  >
    {children}
  </Box>
);
